import { capitalize } from '../helper';
import View from './View';
import icons from 'url:../../img/sprite.svg';

class ProfileView extends View {
  _parentElement = document.querySelector('.main');
  //   _formElement;
  // _passwordElement;
  _errorMessage = 'Profile Error Message';
  _message = 'Profile Success Message';

  addHandlerSave(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const save = e.target.closest('.profile__btn--save');
      if (!save) return;
      const formData = document.querySelector('.profile');

      formData.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const dataArr = [...new FormData(this)];
        const data = Object.fromEntries(dataArr);

        handler(data);
      });
    });
  }

  addHandlerPassword(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const updatePass = e.target.closest('.profile__update');
      if (!updatePass) return;
      const formData = document.querySelector('.profile__password');

      formData.addEventListener('submit', function (e) {
        e.preventDefault();
        e.stopImmediatePropagation();

        const dataArr = [...new FormData(this)];
        const data = Object.fromEntries(dataArr);

        handler(data);
      });
    });
  }

  addHandlerLogout(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const logout = e.target.closest('.profile__btn--logout');
      if (!logout) return;
      handler();
    });
  }

  addHandlerRenderProductAdd(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const addProduct = e.target.closest('.product__upload--add');
      if (!addProduct) return;

      handler();
    });
  }

  addHandlerRenderProductEdit(handler) {
    this._parentElement.addEventListener('click', function (e) {
      const editProduct = e.target.closest('.product__upload--update');
      if (!editProduct) return;

      handler();
    });
  }

  addHandlerRenderAdminOrderlist(handler) {
    const ordersBtn = document.querySelector('.order__admin--list');
    if (!ordersBtn) return;

    ordersBtn.addEventListener('click', handler);
  }

  _generateMarkup() {
    const user = this._data;

    return `
      <div class="row profile__container">
        <h2 class="profile__heading"contenteditable="true">${capitalize(user.name)}</h2>
        
        <div class="profile__details">
          <div class="profile__head">              
            <div class="profile__cta">            
                ${
                  user.role && user.role === 'admin'
                    ? `
                    <div class="profile__role">
                        <h3 class="profile__heading--sub">Admin</h3>
                    </div>
                    <div class="profile__admin--control">
                        <button class="product__upload product__upload--add">
                          <svg class="icon ">
                            <use xlink:href="${icons}#icon-clone"></use>
                          </svg>
                          Add Product
                        </button>
                    </div>            
                    <div class="profile__admin--control">
                      <button class="product__upload product__upload--update"> 
                        <svg class="icon ">
                          <use xlink:href="${icons}#icon-edit"></use>
                        </svg>
                        Edit Product     
                      </button>          
                    </div>   
                    <div class="profile__admin--control">
                      <button class="product__upload order__admin--new"> 
                        <svg class="icon ">
                          <use xlink:href="${icons}#icon-calendar-plus-o"></use>
                        </svg>
                        New Order    
                      </button>          
                    </div>                 
                    <div class="profile__admin--control">
                      <button class="product__upload order__admin--list"> 
                        <svg class="icon ">
                          <use xlink:href="${icons}#icon-database"></use>
                        </svg>
                        Orders     
                      </button>          
                    </div>                  
                
                  `
                    : ''
                }

              <div class="profile__cta--container">
                <button class="btn profile__btn--logout">
                  <svg class="icon ">
                    <use xlink:href="${icons}#icon-power-off"></use>
                  </svg>
                  Logout</button>
              </div>
            </div>                      
          </div> 

          <div class="profile__detail">
            <form action="#" class="profile">
              <div class="label-input"">
                <label for="name">Name:</label>
                <input type="text" id="name" required name="name" value="${user.name}"/>
              </div>
              <div class="label-input"">
                <label for="email">Email:</label>
                <input type="email" id="email" required name="email" value="${user.email}"/>
              </div>
              <div class="label-input"">
                <label for="mobile">Mobile:</label>
                <input type="tel" id="mobile" maxlength="10" minlength="10" name="mobile" value="${user.mobile ? user.mobile : ''}" />
              </div>
              <div class="profile__btn-container"">
                <button type="submit" class="btn profile__btn--save">Save</button>
              </div>
            </form>
            <form action="#" class="profile__password">
              <div class="label-input"">
                <label for="password">Password:</label>
                <input
                  type="password"
                  id="password"
                  name="passwordCurrent"
                  required
                />
              </div>
              <div class="label-input">
                <label for="password-new">New Password:</label>
                <input type="password" id="password-new" name="password" required />
              </div>
              <div class="label-input">
                <label for="password-confirm">Confirm Password:</label>
                <input
                  type="password"
                  id="password-confirm"
                  name="passwordConfirm"
                  required
                />
              </div>
              <div class="profile__btn-container">
                <button type="submit" class="btn profile__update">
                  Update Password
                </button>
              </div>
            </form>
          </div> 
        </div>
      </div>
    `;
  }
}

export default new ProfileView();
